import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-white">
        <div className="brut-card p-8 font-display uppercase tracking-widest" data-testid="loading-indicator">
          Loading...
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  if (roles && !roles.includes(user.role)) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="brut-card p-8" data-testid="forbidden">
          <h2 className="font-display text-3xl uppercase">Forbidden</h2>
          <p className="mt-2 text-sm">You do not have access to this page.</p>
        </div>
      </div>
    );
  }
  return children;
}
